import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from "@ngx-translate/core";
import { lang_cerv3 } from 'app/idiomas/i18n/cerV3/cerv3.lang';
import { MatSnackBar } from "@angular/material/snack-bar";
import * as $ from 'jquery';
import Swal from 'sweetalert2';

import { PreguntasService } from "../../preguntas.service";
import { ModalComponent } from "../preguntas/modal/modal.component";
import { DomSanitizer } from '@angular/platform-browser';
import {MatDialog} from '@angular/material/dialog';


@Component({
  selector: 'traducciones',
  templateUrl: './traducciones.component.html',
  styleUrls: ['./traducciones.component.scss']
})
export class TraduccionesComponent implements OnInit {

  comunicacionIdiomas: any;
  @Input() idiomasGuardados: Observable<any>;
  comunicacionSecciones: any;
  @Input() seccionesGuardadas: Observable<any>;
  comunicacionStatusCompletado: any;
  @Input() statusPaso: Observable<any>;

  @Output() actualizaCuestionario: EventEmitter<any> = new EventEmitter();
  @Output() traduccionesCompletas: EventEmitter<any> = new EventEmitter();

  cargando = true;
  guardando: boolean;
  pasoCompleto: boolean;

  practicas: any;
  idiomas: any;
  idiomaNative: string;
  indiceNative: string;
  idiomasAdicionales: any[] = [];
  traducciones: any;
  traduccionesOriginal: any;

  configTemplate: any;
  jsonCuestionario: any;
  tipoSeccion: any;
  seccionesDemo: any[] = [];

  constructor(
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private preguntasService: PreguntasService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private dialog: MatDialog,
    public sanitizer: DomSanitizer,
  ) {
    lang_cerv3.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    // console.log("entro este vis*************************");
    // console.log(this.idiomasGuardados);
    // console.log(this.seccionesGuardadas);
    // console.log(this.statusPaso);
    this.comunicacionIdiomas = this.idiomasGuardados.subscribe( (datos:any) => {
      if(datos != null){
        console.log("se envio idiomas desde componente base: ",datos);
        this.idiomas = datos;
        let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == "1");
        this.idiomaNative = this.idiomas[indiceIdiomaNativo].nombreIdioma;
        // this.indiceNative = indiceIdiomaNativo;
        this.idiomas.forEach(idioma => {
          if(idioma.tipoIdioma == '0'){
            this.idiomasAdicionales.push(idioma);
          }
        });
        this.cargando = false;
      }else{
        console.log("no se esta enviando nada ");

      }
    });

    this.comunicacionSecciones = this.seccionesGuardadas.subscribe( (datos:any) => {
      if(datos != null){
        console.log("comunicacionSecciones desde componente base: ",datos);
        this.jsonCuestionario = datos.jsonCuestionario;
        this.tipoSeccion = datos.tipoSeccion;
        this.configTemplate = datos.configTemplate;
        let esperaImg = setInterval(() => {
          if(this.idiomaNative != undefined){
            this.setSeccionesDemo(datos.tipoSeccion);
            clearInterval(esperaImg);
          }
        }, 0);
      }
    });
    this.comunicacionStatusCompletado = this.statusPaso.subscribe( (datos:any) => {
      if(datos != null){
        this.pasoCompleto = datos;
      }
    });
  }

  setSeccionesDemo(tipoSeccion: number){
    // console.log("entro setSecciones");

    this.seccionesDemo = [];
    this.jsonCuestionario.sections.forEach((seccion:any) => {
      // console.log("secJson:",seccion);

      if(seccion.typeSection == tipoSeccion){
        // console.log("tipo seccion ",tipoSeccion,":",seccion);
        //revisa el nombre de la seccion si no tiene traduccion
        console.log("idiomaNative:",this.idiomaNative);
        this.indiceNative = seccion.sectionsLanguages.findIndex(item => item.lang == this.idiomaNative);
        console.log("indiceNativoNombre:",this.indiceNative);

        seccion.sectionsLanguages.forEach(nombre => {
          if(nombre.textSection == ""){
            nombre.pendiente = true;
          }
          else nombre.pendiente = false;
        });
        if(tipoSeccion == 6){
          seccion.pendientesForAll = false;
        }
        if(tipoSeccion == 1 || tipoSeccion == 3 || tipoSeccion == 4 || tipoSeccion == 7){ //revisa las preguntas con opciones de respuestas vacias
          seccion.questions.forEach(pregunta => {
            if(pregunta.answers){
              pregunta.answers.forEach(respuesta => {
                respuesta.answerLanguage.forEach(traduccion => {
                  if(traduccion.tag == ""){
                    traduccion.pendiente = true;
                  }
                  else traduccion.pendiente = false;
                });
              });
            }
          });
        }
        //revisa las preguntas que aun no tienen traduccion
        seccion.questions.forEach(pregunta => {
          pregunta.questionLanguage.forEach(traduccion => {
            if(traduccion.question == ""){
              traduccion.pendiente = true;
            }
            else traduccion.pendiente = false;
          });
        });
        // console.log("seccionLista:",seccion);

        this.seccionesDemo.push(seccion);
      }
    });
    this.traduccionesOriginal = JSON.parse(JSON.stringify(this.seccionesDemo));
    this.revisaTraduccionesCompletas();
    console.log("seccionesDemoTranslate:",this.seccionesDemo);
  }

  revisaTraduccionesCompletas(){
    console.log("idiomasAdicionales:",this.idiomasAdicionales);
    let traduccionesOK = true;
    let BreakException = {};
    try {
      this.jsonCuestionario.sections.forEach((seccion:any) => {
        if(seccion.typeSection == this.tipoSeccion){
          this.idiomasAdicionales.forEach(langAdicional => {
            //revisa el nombre de la seccion si no tiene traduccion
            let BrkExc1 = {};
            let tradNombreOk = true;
            console.log("textnative:",seccion.sectionsLanguages[this.indiceNative].textSection,"mandatory:",this.configTemplate.secNombresObligatorios);

            if(!this.configTemplate.secNombresObligatorios){
              if(seccion.sectionsLanguages[this.indiceNative].textSection != ""){
                try {
                  seccion.sectionsLanguages.forEach(nombre => {
                    if(nombre.lang == langAdicional.nombreIdioma){
                      console.log("mandatory:",this.configTemplate.secNombresObligatorios,"nombre:",nombre.textSection);

                      if(nombre.textSection == ""){
                        tradNombreOk = false;
                        throw BrkExc1;
                      }
                    }
                  });
                } catch (e) {
                  if (e !== BrkExc1) throw e;
                };
              }
            }
            else{
              try {
                seccion.sectionsLanguages.forEach(nombre => {
                  if(nombre.lang == langAdicional.nombreIdioma){
                    console.log("mandatory:",this.configTemplate.secNombresObligatorios,"nombre:",nombre.textSection);

                    if(nombre.textSection == ""){
                      tradNombreOk = false;
                      throw BrkExc1;
                    }
                  }
                });
              } catch (e) {
                if (e !== BrkExc1) throw e;
              };
            }

            if(!tradNombreOk){
              traduccionesOK = false;
              throw BreakException;
            }

            //revisa las preguntas de respuestas si acaso la seccion actual es una donde haya preguntas de ese tipo
            if(this.tipoSeccion == 1 || this.tipoSeccion == 3 || this.tipoSeccion == 4 || this.tipoSeccion == 7){
              let BrkExc2 = {};
              let tradRespOk = true;
              try {
                seccion.questions.forEach(pregunta => {
                  let BrkInt1 = {};
                  let tradInt1Ok = true;
                  try {
                    pregunta.answers.forEach(respuesta => {
                      let BrkInt2 = {};
                      let tradInt2Ok = true;
                      try {
                        respuesta.answerLanguage.forEach(traduccion => {
                          if(traduccion.lang == langAdicional.nombreIdioma){
                            if(traduccion.tag == ""){
                              tradInt2Ok = false;
                              throw BrkInt2;
                            }
                          }
                        });
                      } catch (e) {
                        if (e !== BrkInt2) throw e;
                      };
                      if(!tradInt2Ok){
                        tradInt1Ok = false;
                        throw BrkInt1;
                      }
                    });
                  } catch (e) {
                    if (e !== BrkInt1) throw e;
                  };
                  if(!tradInt1Ok){
                    tradRespOk = false;
                    throw BrkExc2;
                  }
                });
              } catch (e) {
                if (e !== BrkExc2) throw e;
              };
              if(!tradRespOk){
                traduccionesOK = false;
                throw BreakException;
              }
            }
            //revisa las preguntas que aun no tienen traduccion
            let BrkExc2 = {};
            let tradRespOk = true;
            try {
              seccion.questions.forEach(pregunta => {
                let BrkInt1 = {};
                let tradPregOk = true;
                try {
                  pregunta.questionLanguage.forEach(traduccion => {
                    if(traduccion.lang == langAdicional.nombreIdioma){
                      if(traduccion.question == ""){
                        tradPregOk = false;
                        throw BrkInt1;
                      }
                    }
                  });
                } catch (e) {
                  if (e !== BrkInt1) throw e;
                };
                if(!tradPregOk){
                  tradRespOk = false;
                  throw BrkExc2;
                }
              });
            } catch (e) {
              if (e !== BrkExc2) throw e;
            };
            if(!tradRespOk){
              traduccionesOK = false;
              throw BreakException;
            }

          });
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    console.log("traduccionesCompletas:",traduccionesOK);
    this.traduccionesCompletas.emit(traduccionesOK);
  }

  guardaTraduccionNombre(event:any, datosTraduccion:any, indiceSeccion:number, indiceIdioma:number){
    if(event.target.value.length >= 1){
      if(this.traduccionesOriginal[indiceSeccion].sectionsLanguages[indiceIdioma].textSection != event.target.value)
      {
        // this.guardando = true;
        $(document).ready(function(){ $(':focus').blur(); });
        this.modalGuardado(1);
        console.log("datosTraduccion:",datosTraduccion);
        if(datosTraduccion.pendiente){
          this.actualizaCuestionario.emit({status:true});
          datosTraduccion.pendiente = false;
          this.traduccionesOriginal[indiceSeccion].sectionsLanguages[indiceIdioma].textSection = event.target.value
        }
        else{
          this.actualizaCuestionario.emit({status:true});
          this.traduccionesOriginal[indiceSeccion].sectionsLanguages[indiceIdioma].textSection = event.target.value
        }
      }
      else console.log("es el mismo texto nomms :v");

    }
  }

  guardaTraduccion(event:any, datosPregunta:any, datosTraduccion:any, indiceSeccion:number, indicePregunta:number, indiceIdioma:number){
    if(event.target.value.length >= 1){
      if(this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].questionLanguage[indiceIdioma].question != event.target.value)
      {
        // this.guardando = true;
        $(document).ready(function(){ $(':focus').blur(); });
        this.modalGuardado(2);
        console.log("datosPregunta:",datosPregunta);
        console.log("datosTraduccion:",datosTraduccion);
        if(datosPregunta.idUnique < 99999){  //pregunta de catalogo
          //Cambia el typeAdd si la pregunta es de catalogo, (en template o recien agregada)
          if(datosPregunta.typeAdd == 0 || datosPregunta.typeAdd == 1){
            datosPregunta.typeAdd = 4;
          }
          if(datosTraduccion.pendiente){  //si la traduccion esta pendiente, la guarda al catalogo actualizando la pregunta
            this.preguntasService.getPreguntaCatMaster(datosPregunta.idUnique).subscribe((respuesta:any) => {
              console.log("getPreguntaCatMaster:",respuesta);
              let datosPreguntaCat = respuesta.question;
              let indiceVersionPregCat = datosPreguntaCat.textVersions.findIndex(item => item.versionId == datosPregunta.versionId);
              let indiceLangVersPregCat = datosPreguntaCat.textVersions[indiceVersionPregCat].questionLanguage.findIndex(item => item.lang == datosTraduccion.lang);
              if(indiceLangVersPregCat != -1){
                datosPreguntaCat.textVersions[indiceVersionPregCat].questionLanguage[indiceLangVersPregCat].question = event.target.value;
              }
              console.log("datosPreguntaCatMod:",datosPreguntaCat);
              this.actualizaPreguntaCatMaster(datosPreguntaCat, {indiceSeccion,indicePregunta,indiceIdioma,event});
              datosTraduccion.pendiente = false;
            });
          }
          else{
            this.actualizaCuestionario.emit({status:true});
            datosTraduccion.pendiente = false;
            this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].questionLanguage[indiceIdioma].question = event.target.value
          }
        }
        else{ //pregunta de template
          this.actualizaCuestionario.emit({status:true});
          datosTraduccion.pendiente = false;
          this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].questionLanguage[indiceIdioma].question = event.target.value;
        }
      }
      else console.log("es el mismo texto nomms :v");

    }
  }

  guardaTraduccionOpcion(event:any, datosPregunta:any, datosRespuesta:any, datosTraduccion:any, indiceSeccion:number, indicePregunta:number, indiceRespuesta:number, indiceIdioma:number){
    if(event.target.value.length >= 1){
      if(this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].answers[indiceRespuesta].answerLanguage[indiceIdioma].tag != event.target.value)
      {
        // this.guardando = true;
        $(document).ready(function(){ $(':focus').blur(); });
        this.modalGuardado(3);
        console.log("datosTraduccion:",datosTraduccion);
        if(datosPregunta.idUnique < 99999){  //pregunta de catalogo
          //Cambia el typeAdd si la pregunta es de catalogo, (en template o recien agregada)
          if(datosPregunta.typeAdd == 0 || datosPregunta.typeAdd == 1 || datosPregunta.typeAdd == 4){
            datosPregunta.typeAdd = 5;
          }
          //Cambia el typeAdd de la respuesta si la pregunta esta en catalogo y no es nueva
          if(datosRespuesta.typeAdd == 0){
            datosRespuesta.typeAdd = 5;
          }
          if(datosTraduccion.pendiente){  //si la traduccion esta pendiente, la guarda al catalogo actualizando la pregunta
            this.preguntasService.getPreguntaCatMaster(datosPregunta.idUnique).subscribe((respuesta:any) => {
              console.log("getPreguntaCatMaster:",respuesta);
              let datosPreguntaCat = respuesta.question;
              let indiceVersionRespCat = datosPreguntaCat.answers[indiceRespuesta].textVersions.findIndex(item => item.versionId == datosRespuesta.versionId);
              let indiceLangVersRespCat = datosPreguntaCat.answers[indiceRespuesta].textVersions[indiceVersionRespCat].answerLanguage.findIndex(item => item.lang == datosTraduccion.lang);
              if(indiceLangVersRespCat != -1){
                datosPreguntaCat.answers[indiceRespuesta].textVersions[indiceVersionRespCat].answerLanguage[indiceLangVersRespCat].tag = event.target.value;
              }
              console.log("datosPreguntaCatMod:",datosPreguntaCat);
              this.actualizaPreguntaCatMaster(datosPreguntaCat, {indiceSeccion,indicePregunta,indiceIdioma,event});
              datosTraduccion.pendiente = false;
            });
          }
          else{
            this.actualizaCuestionario.emit({status:true});
            datosTraduccion.pendiente = false;
            this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].questionLanguage[indiceIdioma].question = event.target.value
          }
        }
        else{ //pregunta de template
          this.actualizaCuestionario.emit({status:true});
          datosTraduccion.pendiente = false;
          this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].questionLanguage[indiceIdioma].question = event.target.value;
        }
      }
      else console.log("es el mismo texto nomms :v");

    }
  }

  actualizaPreguntaCatMaster(pregunta:any, datosSeccionOriginal?:any, preguntaCorregida?:boolean, numeroPregCorregida?:number){
    this.preguntasService.setPreguntaCatMaster(pregunta).subscribe((respuesta:any) => {
      // console.log("setPreguntaCatMaster:",respuesta);
      if(respuesta.success){
        if(datosSeccionOriginal != null){
          //actualizar json cuestionario
          console.log('datosSeccionOriginal',datosSeccionOriginal);
          console.log('this.traduccionesOriginal',this.traduccionesOriginal);

          this.traduccionesOriginal[datosSeccionOriginal.indiceSeccion].questions[datosSeccionOriginal.indicePregunta].questionLanguage[datosSeccionOriginal.indiceIdioma].question = datosSeccionOriginal.event.target.value;
          this.actualizaCuestionario.emit({status:true, getCatalogo:true});
        }
        else if(preguntaCorregida){
          console.log("numero de pregunta corregida: ",numeroPregCorregida,", datos:",pregunta);

        }
      }
    });
  }

  modalGuardado(opcion:number){
    let mensaje: string;
    switch (opcion) {
      case 1:
        // this.translate.get('Guardando traducción del nombre, espere por favor').subscribe((res: string) => { mensaje = res; });
        mensaje = this.translateSrv.instant('CERTIFICARV3.TAB_TRADUCCION.GUAR_TRA_NAM')
      break;
      case 2:
        // this.translate.get('Guardando traducción de la pregunta, espere por favor').subscribe((res: string) => { mensaje = res; });
        mensaje = this.translateSrv.instant('CERTIFICARV3.TAB_TRADUCCION.GUAR_TRA_PRE')
      break;
      case 3:
        // this.translate.get('Guardando traducción de la opción de respuesta, espere por favor').subscribe((res: string) => { mensaje = res; });
        mensaje = this.translateSrv.instant('CERTIFICARV3.TAB_TRADUCCION.GUAR_TRA_RES')
      break;
    }
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.revisaTraduccionesCompletas();
  }

  openSuccessSnackBar(message: string, action: string) {
     this.snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['background-success']
     });
  }

  //FUNCION DE PRUEBA, NO EJECUTAR SI NO ES UNA EMERGENCIA :v
  revisaTraduccionesCatalogo(){
    let tiposPreguntasRevisables = [1,3,4,6];  //preguntas que tienen respuestas
    let catalogoIdiomasSurvey: any;
    let preguntasMal: any[] = [];
    this.preguntasService.getCatIdiomasSurvey().subscribe((respIdiomas:any) => {
      catalogoIdiomasSurvey = respIdiomas.languages;
      this.preguntasService.getCatalogo(localStorage.getItem('instituto_id'), '0').subscribe((respCat:any) => {
        console.log("getCatalogoRevisionTrad:",respCat);

        //fase 1: filtrar preguntas con traducciones faltantes
        respCat.questions.forEach((pregunta:any) => {
          if(tiposPreguntasRevisables.includes(pregunta.answerType)){
            let preguntaFiltrada = false;
            pregunta.answers.forEach(respuesta => {
              respuesta.textVersions.forEach(version => {
                if(version.answerLanguage.length != catalogoIdiomasSurvey.length){
                  if(!preguntaFiltrada){
                    preguntasMal.push(pregunta);
                    preguntaFiltrada = true;
                  }
                }
              });
            });
          }
        });
        let wizardOriginal = JSON.parse(JSON.stringify(preguntasMal));
        console.log("preguntasMal:",wizardOriginal);

        //fase 2: completar los idiomas a las preguntas
        preguntasMal.forEach(pregunta => {
          pregunta.answers.forEach(respuesta => {
            respuesta.textVersions.forEach(version => {
              catalogoIdiomasSurvey.forEach(idioma => {
                if(version.answerLanguage.findIndex(item => item.idLanguage == parseInt(idioma.idLanguage) && item.lang == idioma.abbr) == -1){
                  version.answerLanguage.push({
                    tag: '',
                    vivo: 1,
                    idLanguage: parseInt(idioma.idLanguage),
                    lang: idioma.abbr
                  });
                }
              });
            });
          });
        });
        console.log("preguntasMalCorregidas:",preguntasMal);

        //fase 3: actualizar las preguntas en el catalogo
        preguntasMal.forEach((pregunta,i) => {
          this.actualizaPreguntaCatMaster(pregunta, null, true, (i+1));
        });
      });
    });
  }

  /// FUNCIONES AGREGAR AUDIO

  DEMO_convierteAudioBlob(base64:string){
    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    const contentType = 'audio/mpeg';
    const b64Data = base64;

    const blob = b64toBlob(b64Data, contentType);
    const blobUrl = URL.createObjectURL(blob);
    // this.blobAudio = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    return blobUrl;
  }

  DEMO_agregarAudioPregunta(datosPregunta:any, tipo:string, datosPregSP:any){
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose: true,
      width: '60%',
      data: {
        opcion: 'nuevoAudio',
        tipo,
        idiomas: this.idiomas,
        datosPregunta,
        // pregCat: this.datos.pregCat,
        datosPregSP,
        recuperarPregCat: true,
        audioTraduccion: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        if(result.base64 != undefined){
          datosPregunta.audio = true;
          datosPregunta.audioData = '';
          datosPregunta.audioUrl = ''
          setTimeout(() => {
            datosPregunta.audioData = result.base64;
            datosPregunta.audioUrl = result.url
            this.actualizaCuestionario.emit({status:true});
          });
        }
      }
    });
  }

  DEMO_reproducirAudioPregunta(datosPregunta:any){
    datosPregunta.audioUrl = this.DEMO_convierteAudioBlob(datosPregunta.audioData);
  }

  DEMO_borrarAudioPregunta(datosPregunta:any){
    Swal.fire({
      icon: 'question',
      title: '¿Está seguro de borrar la pista de audio asociada a esta pregunta?',
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        const codigo = Math.random().toString(36).substring(7);
        Swal.fire({
          title: 'Para confirmar, ingrese el codigo en rojo en la caja de texto:\n\n' + '<font color="red">' + codigo + '</font>',
          icon: 'info',
          input:'text',
          showCancelButton: true,
          reverseButtons: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Aceptar'
        }).then( (borrar) => {
          if (borrar.value == codigo) {
            datosPregunta.audio = false;
            datosPregunta.audioData = '';
            datosPregunta.audioUrl = '';
            this.openSuccessSnackBar('Se borró la pista de audio de la pregunta correctamente', "OK");
          } else{
            if(!borrar.dismiss){
              Swal.fire({
                icon: 'error',
                title:  'El codigo ingresado, no coincide con el indicado en rojo',
                showConfirmButton: true,
                confirmButtonText: 'Aceptar'
              })
            }
          }
        });
      }
    });
  }

}
